import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e54c3ce2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = { class: "text" }
const _hoisted_5 = {
  key: 0,
  class: "bottom"
}

import GenericButton from "@/components/buttons/GenericButton.vue";
import ChatMessageContent from "@/components/chat/chatContainer/ChatMessageContent/ChatMessageContent.vue";
import { ActionTypes } from "@/store";
import {
  FriendRequestMessage,
  FriendRequestStatus,
  Message,
} from "@/store/chats/types";
import { GenericButtonVariantEnum } from "@/types/button";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

interface ChatMessageProps {
  message: FriendRequestMessage;
  index: number;
  visibleMessages: Message[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatFriendRequestMessage',
  props: {
    message: {},
    index: {},
    visibleMessages: {}
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n();
const { dispatch } = useStore();

const handleUpdateFriendRequest = async (status: FriendRequestStatus) => {
  await dispatch(ActionTypes.UPDATE_FRIEND_REQUEST, {
    userId: props.message.senderId,
    status,
  });
};

// TODO: add button handlers
const handleDecline = async () => {
  await handleUpdateFriendRequest(FriendRequestStatus.Cancelled);
};

const handleAccept = async () => {
  await handleUpdateFriendRequest(FriendRequestStatus.Accepted);
};

const isRequestForResponding = computed(() => {
  return (
    props.message.status === FriendRequestStatus.Pending &&
    !props.message.isMine
  );
});

const appliedText = computed(() => {
  if (
    props.message.isMine &&
    props.message.status !== FriendRequestStatus.Accepted
  ) {
    return t("chat.chatContainer.messages.friendRequest.requestSent");
  }
  if (props.message.isMine) {
    return t("chat.chatContainer.messages.friendRequest.accepted");
  }

  if (props.message.status === FriendRequestStatus.Pending) {
    return t("chat.chatContainer.messages.friendRequest.acceptInvitation");
  }

  if (props.message.status === FriendRequestStatus.Accepted) {
    return t("chat.chatContainer.messages.friendRequest.accepted");
  }

  return t("chat.chatContainer.messages.friendRequest.declined");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChatMessageContent, {
    index: _ctx.index,
    message: _ctx.message,
    "visible-messages": _ctx.visibleMessages
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["friend-request-message", { isRequestForResponding: isRequestForResponding.value }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (isRequestForResponding.value)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_ctx.$t(
                "chat.chatContainer.messages.friendRequest.invitationFromUser",
                {
                  userName: _ctx.message.senderName,
                },
              )), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_4, _toDisplayString(appliedText.value), 1)
          ]),
          (isRequestForResponding.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(GenericButton, {
                  text: "chat.chatContainer.messages.friendRequest.declineButtonText",
                  variant: _unref(GenericButtonVariantEnum).Secondary,
                  onClick: handleDecline
                }, null, 8, ["variant"]),
                _createVNode(GenericButton, {
                  text: "chat.chatContainer.messages.friendRequest.acceptButtonText",
                  onClick: handleAccept
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["index", "message", "visible-messages"]))
}
}

})